/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Members_Reset_Credentials_DescriptionInputs */



/**
* | output |
* | --- |
* | "Reset credentials for {email}? They will need to use a new setup token to access their account." |
*
* @param {Members_Reset_Credentials_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_reset_credentials_description = /** @type {((inputs: Members_Reset_Credentials_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Reset_Credentials_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Anmeldedaten für ${i?.email} zurücksetzen? Sie müssen ein neues Setup-Token verwenden, um auf ihr Konto zuzugreifen.`)
	return /** @type {LocalizedString} */ (`Reset credentials for ${i?.email}? They will need to use a new setup token to access their account.`)
});